import clsx from 'clsx'
import { webchatClasses } from '../../styles'

type Props = {
  className?: string
}
export const Loader = ({ className, ...props }: Props) => {
  const { className: loaderClassName } = webchatClasses.loader
  return <div {...props} className={clsx(className, loaderClassName)} />
}
